const LOGGED_IN_USER_ID_KEY = '@stockeasy:loggedInUserId';
const DEVICE_ID_KEY = '@stockeasy:deviceId';

export {
    LOGGED_IN_USER_ID_KEY,
    DEVICE_ID_KEY,
};